
// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import axios from 'axios';

// const UserDetailPage = () => {
//   const { id } = useParams();
//   const [user, setUser] = useState(null);

//   useEffect(() => {
//     axios.get(`http://localhost:8080/api/v1/admin/users/${id}`, { withCredentials: true })
//       .then(res => setUser(res.data))
//       .catch(err => console.error(err));
//   }, [id]);

//   if (!user) return <div className="p-8">Loading user...</div>;

//   return (
//     <div className="p-8 bg-gray-100">
//       <h2 className="text-2xl font-bold mb-4">User Details</h2>
//       <div className="bg-white p-6 rounded-xl shadow space-y-4">
//         <p><strong>ID:</strong> {user._id}</p>
//         <p><strong>Name:</strong> {user.username}</p>
//         <p><strong>Mobile:</strong> {user.mobileNumber}</p>
//         <p><strong>Gender:</strong> {user.gender}</p>
//         <p><strong>Status:</strong> {user.status}</p>
//         <p><strong>Role:</strong> {user.role}</p>
//       </div>
//     </div>
//   );
// };

// export default UserDetailPage;

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import DashSide from '../components/DashSide';

const UserDetailPage = () => {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [activePage, setActivePage] = useState('users');
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`/api/v1/admin/users/${id}`, { withCredentials: true })
      .then(res => setUser(res.data))
      .catch(err => console.error(err));
  }, [id]);

  const handleNavigate = (page) => {
    setActivePage(page);
    if (page === 'dashboard') navigate('/admin-dashboard');
    if (page === 'users') navigate('/admin-dashboard'); // or another users route
    if (page === 'messages') navigate('/admin-dashboard'); // or messages route
  };

  if (!user) return <div className="p-8">Loading user...</div>;

  return (
    <div className="flex w-screen min-h-screen bg-gray-100">
      <DashSide onNavigate={handleNavigate} activePage={activePage} />
      <div className="p-8 bg-gray-100 flex-1 overflow-y-auto">
        <h2 className="text-2xl font-bold mb-4">User Details</h2>
        <div className="bg-white p-6 rounded-xl shadow space-y-4">
          <p><strong>ID:</strong> {user._id}</p>
          <p><strong>Name:</strong> {user.username}</p>
          <p><strong>Email:</strong> {user.email}</p>
          <p><strong>Mobile:</strong> {user.mobileNumber}</p>
          
          {/* <p><strong>Gender:</strong> {user.gender}</p>
          <p><strong>Status:</strong> {user.status}</p>
          <p><strong>Role:</strong> {user.isRole}</p> */}
        </div>
      </div>
    </div>
  );
};

export default UserDetailPage;
